import styled from '@emotion/styled';

export const Input = styled.input`
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 10px;
  height: 10px;

  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 16px;
    height: 16px;
    top: 0;
    left: 0;
    border: 2px solid ${(props) => props.theme.color.light.shade};
    border-radius: 2px;
    background-color: white;
  }

  &:checked:before {
    border-color: ${(props) => props.theme.color.blue.default};
  }

  &:checked:after {
    content: '';
    display: block;
    width: 4px;
    height: 8px;
    border: solid ${(props) => props.theme.color.blue.default};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    position: absolute;
    top: 3px;
    left: 6px;
  }

  text-align: left;
`;

export const Label = styled.label<{ disabled: boolean }>`
  margin-left: 10px;
  color: ${(props) => props.theme.color.medium.shade};
  font-weight: 500;
  font-size: 14px;
  text-align: left;
`;
